import { useEffect, useState } from "react"
import { IoGrid, IoList } from "react-icons/io5"
import { useTranslation } from "react-i18next"
import SelectBox from "components/Commons/SelectBox/SelectBox"
import SummaryOptions from "overrides/theme/entel/base/components/Summary/SummaryOptions"
import { useEnv } from "hooks"
import Loading from "overrides/theme/entel/base/components/Commons/Loading/Loading"
import { useOrderGrouped } from "overrides/theme/entel/base/hooks"

const DashboardContent = (children: any) => {
  let { data, class_modifier, title, select_options } = children
  const { t } = useTranslation()
  const [view, set_view] = useState("block")
  const [data_status, set_data_status]: any = useState(null)
  const [loading, set_loading] = useState(false)
  const [select_value, select_dispatch] = useState(() => (!!select_options ? select_options[0]["id"] : null))

  const { core, sg } = useEnv()
  const sg_list_all = sg.get_sg_shippingtype_list_all()
  const { order_group_formatted } = useOrderGrouped()

  const event_set_view = (type_view: any) => {
    if (view !== type_view) set_view(type_view)
  }

  const event_set_select = (value: any) => select_dispatch(value)

  useEffect(() => {
    if (select_value !== null) {
      const fetch_data = async () => {
        set_loading(true)
        const response = await order_group_formatted(
          select_value.split(","),
          core.get_status_list_complex(sg_list_all, select_value.split(",")),
        )
        set_data_status(response)
        set_loading(false)
      }
      fetch_data()
    }
    //eslint-disable-next-line
  }, [select_value])

  const template = (
    <>
      {loading && <Loading defaultOpened={true} />}
      <section
        className={`dashboard__content__children dashboard__content__children--${class_modifier} dashboard__content__children--${view}`}
      >
        <article className="dashboard__content__children__header">
          <div className="dashboard__content__children__header__title">
            <h3>{t(title)}</h3>
          </div>
          <div className="dashboard__content__children__header__options">
            <div
              className="dashboard__content__children__header__options__item dashboard__content__children__header__options__item--block"
              onClick={() => event_set_view("block")}
            >
              <p>{t("Vista Resumen")}</p> <IoGrid />
            </div>
            <div
              className="dashboard__content__children__header__options__item dashboard__content__children__header__options__item--list"
              onClick={() => event_set_view("list")}
            >
              <p>{t("Vista Lista")}</p> <IoList />
            </div>
          </div>
        </article>
        <article className="dashboard__content__children__filters">
          {!!select_options && (
            <>
              <p>{t("Filtrar por")}</p>
              <div className="dashboard__content__children__filters__select">
                <SelectBox options={select_options} onchange={event_set_select} defaultValue={select_options[0]} />
              </div>
            </>
          )}
        </article>
        <article className="dashboard__content__children__items">
          {!!data_status && <SummaryOptions summaryOptions={data_status} />}
          {!!data && <SummaryOptions summaryOptions={data} />}
        </article>
      </section>
    </>
  )

  return template
}

export default DashboardContent
